<template lang="html">
  <nav>
    <div :class="['true-nav', showNav ? '' : 'nav-hidden']">
      <p>[{{ callsign.toUpperCase() }}] <span class="tertiary">◆</span> [{{ nickname.toUpperCase() }}] <span class="tertiary">◆</span> Day {{ currentDay }}</p>
      <router-link v-if="showHiddenLinks" to="/">Landing</router-link>
      <router-link v-if="showHiddenLinks" to="/intro">Intro</router-link>
      <router-link v-if="showHiddenLinks" to="/setup">Setup</router-link>
      <router-link to="/logs">Logs</router-link>
      <router-link to="/reports">Reports</router-link>
      <router-link v-if="showHiddenLinks" to="/transition">Transition</router-link>
      <router-link v-if="showHiddenLinks" to="/outro">Outro</router-link>
      <router-link to="/settings">Settings</router-link>
      <router-link to="/welcome">Exit</router-link>
    </div>
    <div :class="['backlight', showNav ? '' : 'nav-hidden']">
      <p>[{{ callsign.toUpperCase() }}]<span class="tertiary">███</span>[{{ nickname.toUpperCase() }}]<span class="tertiary">███</span>Day {{ currentDay }}</p>
      <router-link v-if="showHiddenLinks" to="/">███████</router-link>
      <router-link v-if="showHiddenLinks" to="/intro">█████</router-link>
      <router-link v-if="showHiddenLinks" to="/setup">█████</router-link>
      <router-link to="/logs">████</router-link>
      <router-link to="/reports">███████</router-link>
      <router-link v-if="showHiddenLinks" to="/transition">██████████</router-link>
      <router-link v-if="showHiddenLinks" to="/ending">█████</router-link>
      <router-link to="/settings">████████</router-link>
      <router-link to="/welcome">████</router-link>
    </div>
  </nav>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Nav',
  props: {
    showNav: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showHiddenLinks: false,
    }
  },
  computed: {
    ...mapState({
      callsign: state => state.playerDetails.pilot.callsign,
      nickname: state => state.playerDetails.carapace.nickname,
      currentDay: state => state.calendar.currentDay,
    }),
  },
}
</script>

<style lang="css" scoped>
.true-nav {
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  padding: 0 56px 0 56px;
  background: var(--primary-color);
  display: flex;
  height: 45px;
  align-items: center;
  z-index: 5;
  transition: transform 1s;
}

.backlight {
  position: fixed;
  width: 100%;
  top: 19px;
  left: 0;
  padding: 0 56px 0 56px;
  display: flex;
  height: 25px;
  align-items: center;
  box-shadow: 0px 0px 50px var(--secondary-color);
  z-index: 4;
  transition: transform 1s;
}

p {
  margin: 0 auto 0 0;
  color: var(--secondary-color);
}

a {
  text-decoration: none;
  margin-left: 20px;
  color: var(--secondary-color);
  transition: color 0.2s;
}

a:hover {
  text-decoration: underline;
}

a.router-link-exact-active {
  text-decoration: underline;
  color: var(--tertiary-color);
}

.backlight > a {
  text-shadow: 0 0 30px rgba(0, 0, 0, 0);
  transition: text-shadow 0.5s;
}

.backlight > a.router-link-exact-active, .tertiary {
  text-shadow: 0 0 30px var(--tertiary-color);
  /* text-shadow: 0 0 200px white; */
  color: var(--tertiary-color);
}

.nav-hidden {
  transform: translate(0, -90px);
}

</style>
